import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import ValueRankingMiddleware from "../../../../middleware/modules/marketing/value-ranking";
import Form from "../../../../components/modules/marketing/value-ranking/form";
import View from "../../../../components/modules/marketing/value-ranking/view";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";

const mapStateToProps = ({ auth, valueRanking }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: valueRanking.isProcessing,
  isError: valueRanking.isError,
  errorMessage: valueRanking.errorMessage,
  data: valueRanking.single,
  isSuccess: valueRanking.isSuccess,
  isReset: valueRanking.isReset,
  isNewRecord: valueRanking.isNewRecord,
  onSubmit: valueRanking.onSubmit,
  helperValue:valueRanking.helperRanking,
  typeModal:valueRanking.typeModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeModal: () => ValueRankingMiddleware.reset(),
      new: (data, search) => ValueRankingMiddleware.beforeSaveNew(data, search),
      helper: (data, search) => ValueRankingMiddleware.getHelper(data, search),
      update: (id, type, search) =>ValueRankingMiddleware.beforeSaveUpdate(id, type, search),
    },
    dispatch
  );
};
class FormContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    dataUpdate: PropTypes.object,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    dataUpdate: null,
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.getData = this.getData.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.close = this.close.bind(this);
  }
  componentDidMount(){
    this.props.helper()
  }

  getData() {
    return this.props.showOne(this.props.dataID);
  }

  close() {
    this.props.closeModal();
  }
  submitForm() {
    const { search } = this.props;
    var form = this.form.current.runSubmit();
    this.props.new(form, search);
  }

  render() {
    const {
      onSubmit,
      showModal,
      titleModal,
      typeModal,
    } = this.props;
    return (
      <>
        <Modal show={showModal} size={"lg"}>
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Helmet>
            <title>{titleModal}</title>
          </Helmet>
          <Modal.Body>
            {typeModal=='form'&& <Form
              {...this.props}
              ref={this.form}
            />}
            {typeModal=='view'&& <View
              {...this.props}
              ref={this.form}
            />}
           
          </Modal.Body>
           {typeModal=='form'&&
            <Modal.Footer className={(!onSubmit)?"justify-content-between":"justify-content-center"}>
              {onSubmit ? (
                ""
              ) : (
                <Button variant="secondary" onClick={() => this.close(false)}>
                  {i18n.t("Close")}
                </Button>
              )}
              <Button variant="primary" onClick={() => ((onSubmit)?false:this.submitForm(true))}>
                {onSubmit ? (
                  <span className="indicator-progress show">
                    {i18n.t("Please wait...")}
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                ) : (
                  <span className="indicator-label">{i18n.t("Save")}</span>
                )}
              </Button>
            </Modal.Footer>
            }

             {typeModal=='view'&&
            <Modal.Footer className={(!onSubmit)?"justify-content-between":"justify-content-center"}>
                <Button variant="secondary" onClick={() => this.close(false)}>
                  {i18n.t("Close")}
                </Button>
            </Modal.Footer>
            }
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
